var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSmWidth)?_c('div',{class:[_vm.$style.background, _vm.classes],style:({ height: _vm.height })},[(_vm.hasValidImage)?_c('SvgSelect',{attrs:{"svg":_vm.image,"width":_vm.dimensions.width,"height":_vm.dimensions.height,"aspect-ratio":_vm.aspectRatio,"svg-props":_vm.dimensions.svgProps}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }